import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Banche, BancheService } from 'my-lib-sanfelici';




@Component({
  selector: 'app-banche-edit',
  templateUrl: './banche-edit.component.html',
  styleUrls: ['./banche-edit.component.css']
})
export class BancheEditComponent implements OnInit {
banca: Banche;
id: string;
  constructor(
    private router: Router,
    private bancheservice: BancheService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.bancheservice.get(this.id).subscribe(b => this.banca = b);
  }
  submit() {
    this.bancheservice.update(this.banca).then(() => {
      this.router.navigate(['/banche']);
    });
      }
}
